import actions from '@/store/modules/left_menu/actions';
import mutations from '@/store/modules/left_menu/mutations';

const moduleLeftMenu = {
  namespaced: true,

  state: {
    items: [],
    settings: {
      open: {
        type: 'mouseover',
        delay: 50,
      },
      close: {
        type: 'mouseout',
        delay: 50,
      },
    },
  },
  getters: {},
  actions: {
    ...actions,
  },
  mutations: {
    ...mutations,
  },
  modules: {},
};

export default moduleLeftMenu;
